export function isPrerender() {
  if (typeof navigator === "undefined") return false;
  return navigator.userAgent === "ReactSnap";
}